/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ActionResource } from '../model/models';
import { GetUserContactsCount200Response } from '../model/models';
import { OfferContactResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface OfferContactServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get user to offer contacts count
     * 
     * @param userId 
     */
    getUserOfferContactsCount(userId?: number, extraHttpRequestParams?: any): Observable<GetUserContactsCount200Response>;

    /**
     * Offer contact an action list
     * 
     * @param callId 
     */
    offerContactActionList(callId: number, extraHttpRequestParams?: any): Observable<Array<ActionResource>>;

    /**
     * Offer contact detail
     * 
     * @param callId 
     */
    offerContactDetail(callId: number, extraHttpRequestParams?: any): Observable<OfferContactResource>;

    /**
     * Offer a contact list
     * 
     */
    offerContactList(extraHttpRequestParams?: any): Observable<Array<OfferContactResource>>;

}
